import React, { useContext, useEffect, useState, useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CategoryIcon from "@mui/icons-material/Category";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Box } from "@mui/system";
import { Chip, Button, Paper, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import DoneIcon from "@mui/icons-material/Done";
import { GridCloseIcon } from "@mui/x-data-grid";
import { ProVerContext, UserContext } from "../../context/userContext";
import { ProVerContextInfo, UserLoginInfo } from "../../types/context";
import { appLogger } from "../../utils";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function ProductVersionDropdown(props: any) {
  const {
    productResponse,
    selectedProVerDataFn,
    selectedProVerData,
    contextProVersion,
  } = props;
  const [result, setresult] = useState<any>([]);
  const [resultdata, setresultdata] = React.useState<any>(result);
  const [rerender, setRerender] = useState(false);
  const [selectedDatas, setselectedDatas] = useState<any>([]);
  const [proverdropdownOpen, setproverdropdownOpen] = useState<any>(false);
  const [ShowErrMsg, setShowErrMsg] = useState<any>(false);
  const [detectRemove, setDetectRemove] = useState<any>(0);

  const inputRef = useRef<HTMLInputElement>(null);

  const {
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    setcontextProVersion,
    contextRedirectProdPage,
  } = useContext(UserContext) as UserLoginInfo;

  const formproductResponse = () => {
    const tempData: any = [];
    productResponse &&
      productResponse.length > 0 &&
      productResponse.forEach((value: any, key: any) => {
        tempData.push({
          value: value.id,
          title: value.name,
          version: value.version,
          proversion: value.name + value.version,
        });
      });
    tempData.sort((a: any, b: any) => a.title.localeCompare(b.title));
    setresult(tempData);
  };

  useEffect(() => {
    formproductResponse();
  }, [productResponse]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "ProductVersionDropdown",
        component: "common",
        fileName: "ProductVersionDropdown.tsx",
        selectedDatas: selectedDatas,
      },
    });
  }, [selectedDatas]);

  const handleClearAll = () => {
    selectedProVerDataFn([]);
    setcontextProVersion([]);
    setselectedDatas([]);
    setShowErrMsg(true);
    setproverdropdownOpen(true);
  };

  useEffect(() => {
    if (!proverdropdownOpen) {
      handleOk();
    }
  }, [selectedDatas]);
  useEffect(() => {
    if (detectRemove) {
      handleRemoveAccount();
    }
  }, [detectRemove]);

  const handleChange = (e: any, data: any) => {
    if (props.type != "cuvo-user-page") {
      const removedItems = selectedDatas.filter(
        (item: any) => !data.includes(item)
      );

      if (removedItems.length > 0) {
        removedItems.forEach((item: any) => {
          callRemoveAPI(item); // Call API for each removed item
        });
      }
    }

    if (data.length == 0) {
      handleClearAll();
    } else {
      setShowErrMsg(false);
      setselectedDatas(data);
      selectedProVerDataFn(data, "Ok");
    }
  };

  const callRemoveAPI = (item: any) => {
    setDetectRemove((prev: any) => prev + 1);
  };
  const handleRemoveAccount = () => {
    if (selectedDatas.length > 0) {
      selectedDatas.type = "confirm";
      selectedProVerDataFn(selectedDatas, "confirm");
      setShowErrMsg(false);
    } else {
      if (contextProVersion && contextProVersion.length == 0) {
        setShowErrMsg(true);
        setproverdropdownOpen(true);
      } else {
        setproverdropdownOpen(false);
        setShowErrMsg(false);
      }
    }
  };
  const handleOk = () => {
    if (selectedDatas.length > 0) {
      selectedDatas.type = "confirm";
      setproverdropdownOpen(false);
      selectedProVerDataFn(selectedDatas, "confirm");
      setShowErrMsg(false);
      if (inputRef.current) {
        inputRef.current.blur();
      }
    } else {
      if (contextProVersion && contextProVersion.length == 0) {
        setShowErrMsg(true);
        setproverdropdownOpen(true);
      } else {
        setproverdropdownOpen(false);
        setShowErrMsg(false);
      }
    }
  };

  const CustomPaper = (props: any) => {
    return <Paper {...props} sx={{ pb: 0 }} className="prod-ver-dd" />;
  };

  const handleFocus = () => {
    setproverdropdownOpen(true);
  };

  const handleBlur = () => {
    if (contextProVersion.length || props.type == "cuvo-user-page") {
      setproverdropdownOpen(false);
      handleOk();
    } else {
      setproverdropdownOpen(true);
    }
  };

  return (
    <div>
      <Autocomplete
        className="prodver-dd"
        open={proverdropdownOpen}
        disabled={props.type == "cuvo-view-tickets" ? true : !result.length}
        onOpen={handleFocus}
        onClose={handleBlur}
        PaperComponent={CustomPaper}
        disableCloseOnSelect
        disableClearable
        disablePortal={false}
        multiple={props.type == "cuvo-user-page" ? false : true}
        id="fixed-tags-demo"
        value={contextProVersion ? contextProVersion : []}
        onChange={handleChange}
        limitTags={1}
        options={result}
        getOptionLabel={(option: any) => {
          if (props.type == "cuvo-user-page") {
            if (option.title) {
              return option.title + " - " + option.version;
            }
            return "Select at least one product";
          }
          return option.title;
        }}
        isOptionEqualToValue={(option, value) =>
          option?.proversion === value?.proversion
        }
        style={{ width: "100%" }}
        renderInput={(params) => (
          <TextField
            {...params}
            className="custom-select err-pro-ver-select"
            inputRef={inputRef}
            onFocus={handleFocus} // Add focus handler
            onBlur={handleBlur} // Add blur handler
            label={
              result &&
              result.length > 0 &&
              contextProVersion &&
              contextProVersion.length == 0 ? (
                "Select at least one account"
              ) : props.type == "cuvo-user-page" ? (
                <div>
                  Accounts and Versions
                  <div style={{ display: "inline-block", color: "red" }}>
                    *
                  </div>{" "}
                </div>
              ) : (
                "Accounts and Versions"
              )
            }
            size="small"
            error={
              result &&
              result.length > 0 &&
              contextProVersion &&
              contextProVersion.length == 0
                ? true
                : false
            }
            sx={{
              paddingRight:
                props.type == "cuvo-user-page" ? "0px" : "32px !important",
            }} // Add padding to the right side
          />
        )}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip
              {...getTagProps({ index })}
              label={option.title + " - " + option.version}
            />
          ));
        }}
        renderOption={
          props && props.type == "cuvo-user-page"
            ? (props, option, { selected }) => {
                return (
                  <>
                    <Box
                      sx={{ whiteSpace: "normal" }}
                      component="li"
                      {...props}
                    >
                      <span className="pro-verison-prod-title">
                        {option.title}
                      </span>
                      &nbsp; - &nbsp;{" "}
                      <span className="pro-verison-prod-title">
                        {option.version}
                      </span>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="end"
                      className="okclear"
                    >
                      <Button
                        id="ok-btn"
                        className="okbtn"
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={handleOk}
                      >
                        <DoneIcon /> Ok
                      </Button>
                    </Box>
                  </>
                );
              }
            : (props: any, option: any, { selected }) => {
                return (
                  <>
                    <Box
                      sx={{ whiteSpace: "normal" }}
                      component="li"
                      {...props}
                    >
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      <span className="pro-verison-prod-title">
                        {option.title}
                      </span>
                      &nbsp; -
                      <span className="pro-verison-prod-title">
                        &nbsp;{option.version}
                      </span>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="end"
                      className="okclear"
                    >
                      <Button
                        id="ok-btn"
                        className="okbtn"
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={handleOk}
                      >
                        <DoneIcon /> Ok
                      </Button>
                      &nbsp;
                      <Button
                        id="clear-btn"
                        className="allclearbtn"
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => {
                          handleClearAll();
                        }}
                      >
                        <GridCloseIcon /> Clear All
                      </Button>
                    </Box>
                  </>
                );
              }
        }
      />
      {ShowErrMsg ? (
        <Typography color="error">Select at least one account</Typography>
      ) : null}
    </div>
  );
}
